module.exports = __webpack_public_path__ + "media/img/austin-fruits-791c433f.jpg";